import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class TranslationService {

    static instance: TranslationService = null;
    _debug: boolean = false;
    debug(msg: string) {
        if (this._debug) {
            console.log("TranslationService: " + msg);
        }
    }

    currentLanguage: string;
    currentMap: Map<string, string>;
    maps = new Map<string, Map<string, string>>();

    dictionaryAvailable$: Subject<boolean>;

    infoTextMaps = new Map<string, Map<string, string>>();
    currentInfoTextMap = new Map<string, string>();

    constructor() {
        TranslationService.instance = this;
        this.dictionaryAvailable$ = new Subject<boolean>();
        this.currentMap = new Map<string, string>();
        this.debug("Constructor.");
    }

    static getInstance() {
        if (this.instance) {
            return this.instance;
        }
        return null;
    }
    replaceIcons(str: string): string {
        if (str == null) {
            return '';
        }
        str = str.replace('\uf468', '{{iconInformation}}');
        str = str.replace('\uf132', '{{iconControl}}');
        str = str.replace('\uf062', '{{iconConfigurationSettings}}');
        str = str.replace('\ue080', '{{iconBack}}');
        str = str.replace('\ue065', '{{iconCheckConfirm}}');
        str = str.replace('\ue046', '{{iconMenu}}');
        str = str.replace('\ue048', '{{iconQuestion}}');
        str = str.replace('<joker> °C', '');
        str = str.replace('<joker>°C', '');
        str = str.replace('<joker> °م', '');
        str = str.replace('<joker> ppm', '');
        str = str.replace('<joker> ج.ف.م', '');
        str = str.replace('<joker> l/min', '');
        str = str.replace('<joker> %bağıl', '');
        // ru
        str = str.replace('<joker> %отн.', '');
        // 
        str = str.replace('<joker> ل/دق.', '');
        str = str.replace('<joker> Min.', '');
        str = str.replace('<joker> Min', '');
        str = str.replace('<joker> أدنى', '');
        str = str.replace('<joker> bar', '');
        str = str.replace('<joker> بار', '');
        str = str.replace('<joker> min.', '');
        str = str.replace('<joker> min', '');
        str = str.replace('<joker> %rel', '');
        str = str.replace('<joker>%wzgl.', '');
        str = str.replace('<joker> %wzgl.', '');
        str = str.replace('<joker> %نس.', '');
        str = str.replace(' <joker>/8', '');
        str = str.replace(' <joker>/4', '');


        str = str.replace('<joker> %', '');
        str = str.replace('<joker> хв.', '');
        str = str.replace('<joker> dak', '');
        str = str.replace('<joker> dak', '');
        str = str.replace('<joker> 分鐘', '');
        str = str.replace('<joker> كلفن', '');
        str = str.replace('<joker> л/хв.', '');
        str = str.replace('<joker> l/dak', '');
        str = str.replace('<joker> л/мин', '');
        str = str.replace('<joker> л/мин', '');
        str = str.replace('<joker> ل/دق', '');
        str = str.replace('<joker> хв.', '');
        str = str.replace('<joker> мин', '');
        str = str.replace('<joker> دقيقة', '');
        str = str.replace('<joker> 分鐘', '');
        str = str.replace('<joker> جزء/مليون', '');


        str = str.replace('<joker> %', '');
        str = str.replace('<joker> K', '');


        str = str.replace(' <joker>', '');
        str = str.replace(' <joker> ', '');
        str = str.replace('<joker> ', '');
        str = str.replace('<joker>', '');

        return str;
    }

    tr(idx: string): string {
        if (this.currentMap.has(idx)) {
            return this.currentMap.get(idx);
        } else {
            if (this.maps.has('en') && this.maps.get('en').has(idx)) {
                //console.log("Defaulting to en for "+idx);
                return this.maps.get('en').get(idx);
            }
            //console.log("Cannot translate to "+this.getCurrentLanguage()+": "+idx);
            return idx;
        }
    }

    public hasLanguage(lng: string): boolean {
        return this.completeSets.includes(lng);
    }


    public useLanguage(lng: string) {
        if (!this.hasLanguage(lng)) {
            this.debug("Cannot use language: " + lng);
            return;
        }

        this.debug("using language: " + lng);
        this.currentLanguage = lng;
        this.debug("Using map for " + lng);
        this.currentMap = this.maps.get(lng);
        this.currentInfoTextMap = this.infoTextMaps.get(lng);
        this.currentLanguage = lng;
    }
    getCurrentLanguage() {
        return this.currentLanguage;
    }

    public setInfoTexts(data: any, countryCode: string) {
        this.debug("Loading info-text for " + countryCode);
        let currentInfoTextMap = new Map<string, string>();
        for (let idx in data) {
            let plainText = "";
            this.debug("Adding " + JSON.stringify(data[idx]));
            let id = data[idx]['id'];
            if (id) {
                currentInfoTextMap.set(id.toString(), data[idx]['info']);
            }
        }
        this.infoTextMaps.set(countryCode, currentInfoTextMap);
        if (this.getCurrentLanguage() == countryCode) {
            this.debug("Setting map to used map.");
            this.currentInfoTextMap = currentInfoTextMap;
        }
    }

    public getInfoText(id: string): string {
        if (this.currentInfoTextMap) {
            return this.currentInfoTextMap.get(id);
        } else {
            return "";
        }
    }
    completeSets = new Array<string>();
    public addToDictionary(data: any, countryCode: string, complete?: boolean): void {
        this.debug("Adding data to " + countryCode);
        if (!this.maps.has(countryCode)) {
            this.maps.set(countryCode, new Map<string, string>());
        }
        let map = this.maps.get(countryCode);
        for (let idx in data) {
            let plainText = "";

            if (data[idx][countryCode] !== undefined) {
                plainText = data[idx][countryCode];
            } else {
                if (data[idx]['en'] !== undefined) {
                    plainText = data[idx]['en'];
                    //console.log("Adding english override element for language "+countryCode);
                } else {
                    console.warn("Native language (" + countryCode + ") not available and I cannot default to english.");
                    //return;
                }
            }
            let translation = this.replaceIcons(plainText);
            switch (idx) {
                case 'SPLASH_AWAY_CONFIRM_SUBLINE_2':
                case 'SPLASH_AWAY_CONFIRM_SUBLINE_3':
                case 'HOME_QUICK_VETO_SUBLINE_1': {
                    translation = plainText;
                }
            }
            map.set(idx, translation);
        }

        if (complete) {
            //console.log("Having a complete set for language: "+countryCode);
            //console.log("Set-Size: "+this.maps.get(countryCode).size);
            this.completeSets.push(countryCode);
        }

        if (this.currentMap == undefined || this.currentMap.size == 0) {
            this.useLanguage(countryCode);
        }
        this.dictionaryAvailable$.next(true);
    }
}
